'use client'
import { FC, PropsWithChildren } from 'react'

import MobileNavBar from '~/src/components/shared/NavBar/MobileNavBar'

import { isRadiusUser } from '~/helpers/auth'

import { tw } from '~/lib/utils'

import { LayoutProps } from '~/app/types'

const MobileLayout: FC<PropsWithChildren<LayoutProps>> = ({
  currentPage,
  user,
  children,
  onOpenSettings,
}) => {
  return (
    <div
      className={tw(
        'h-screen',
        !currentPage?.title && "[grid-template-areas:'sidebar_main'_'sidebar_main']"
      )}
    >
      {currentPage?.title && isRadiusUser(user) && (
        <MobileNavBar title="Mobile Dispatch" onOpenSettings={onOpenSettings} />
      )}
      <div className="min-h-0 overflow-hidden [grid-area:main]">{children}</div>
    </div>
  )
}

export default MobileLayout
